<template>
  <div>
    <!-- <pre>{{courseContent}}</pre>  -->
    <div>
      <h3 class="course-heading">{{ courseContent.name }}</h3>
      <div class="cstm-breadcrumb">
        <p class="bread-menus">Class Description</p>
      </div>
      <h4 class="mb-4">{{ courseContent.description }}</h4>
 
      <!-- {{courseContent.courseContent}} -->
      <!-- <vs-tabs class="cstm-card">
        <vs-tab label="Content" icon-pack="feather" icon="icon-align-justify">
          <div>
            <vs-card>
              <p
                class="mb-3"
                v-html="courseContent.courseContent.content"
                v-if="
                  courseContent.courseContent &&
                  courseContent.courseContent.content != null
                "
              ></p>
            </vs-card>
          </div>
        </vs-tab>
        <vs-tab
          label="Exams"
          icon-pack="feather"
          icon="icon-file-text"
          v-if="parseInt(courseContent.courseSetting.content_visibility)"
        >

        
          <assignment-modal
            :courseSetting="courseContent.courseSetting"
            :lessonAssignment="examData"
            :sectionType="1"
            :platform_customer_id="courseContent.platform_customer_id"
          ></assignment-modal>
        </vs-tab>
          <vs-tab
          label="HomeWork"
          icon-pack="feather"
          icon="icon-file-text"
          v-if="parseInt(courseContent.courseSetting.content_visibility)"
        >
          <assignment-modal
            :courseSetting="courseContent.courseSetting"
            :lessonAssignment="homeworkData"
            :sectionType="1"
            :platform_customer_id="courseContent.platform_customer_id"
          ></assignment-modal>
        </vs-tab>

        <vs-tab label="Files" icon-pack="feather" icon="icon-file">
          <div>
            <div class="flex flex-wrap -mx-2">
              <div
                v-for="(eachFiles, index) in courseContent.courseFiles"
                :key="index"
                class="sm:w-1/2 md:w-1/3 lg:w-1/4 px-2"
              >
                <vs-card class="file-card">
                  <div slot="header">
                    <img
                      class="w-full file-image"
                      :src="eachFiles.file.file_path"
                      alt=""
                    />
                  </div>
                  <h5 class="file-name">{{ eachFiles.file.file_name }}</h5>
                  <p>{{ eachFiles.file.size }}</p>
                  <vs-button
                    color="success"
                    class="float-right"
                    type="flat"
                    @click="downloadImage(eachFiles.file)"
                    icon-pack="feather"
                    icon="icon-download"
                  ></vs-button>

                </vs-card>
              </div>
            </div>
          </div>
        </vs-tab>
      </vs-tabs> -->

    </div>

    <div class="flex flex-wrap justify-end items-center">
      <!-- <div class="sm:w-auto w-full my-1">
        <vs-button
          class="w-full"
          icon-pack="feather"
          icon="icon-chevron-left"
          :to="{
            name: 'CourseDetails1',
            params: { courseId: courseContent.slug },
          }"
          >Back To Course</vs-button
        >
      </div>
      <div class="sm:w-auto w-full my-1" v-if="!courseContent.courseComplete">
        <vs-button
          class="w-full"
          color="success"
          type="border"
          @click="saveComplete(courseContent.id)"
          >Mark As Complete</vs-button
        >
      </div>

      <div class="sm:w-auto w-full my-1" v-else>
        <vs-button class="w-full" color="success" icon-pack="feather" icon="icon-check"
          >Completed</vs-button
        >
      </div> -->

      <div class="sm:w-auto w-full my-1">
        <vs-button
          v-if="
            courseContent.classLesson && courseContent.classLesson.length
          "
          class="w-full"
          icon-pack="feather"
          icon="icon-chevron-right"
          icon-after
          @click="redirectNextLesson()"
          
          >
          Next Lesson

        </vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import { MarkCompleteMixin } from '../mixins/MarkCompleteMixin'
import QuestionModal from './QuestionModal.vue'
import AssignmentModal from './AssignmentModal.vue'
import axios from 'axios'
// import { readFile } from 'xlsx/types'
export default {
  data () {
    return {
      homeworkData:[],
      examData:[],
      reportData:[]
    }
  },
  props: {
    courseContent: {
      required: true,
      default: () => {}
    },
    platform_customer_id:{},
  },
  components: {
    QuestionModal,
    AssignmentModal
  },
  mixins: [MarkCompleteMixin],
  created () {
    console.log(this.courseContent)
    /* this.homeworkData = this.courseContent.courseAssignments.filter(ele => {
      console.log(ele)
      if (ele.assignment) {
        return ele.assignment.assignment_type_id === 2
      }
    })

    this.examData = this.courseContent.courseAssignments.filter(ele => {
      if (ele.assignment) {

        return ele.assignment.assignment_type_id === 4
      }
    })

    this.reportData = this.courseContent.courseAssignments.filter(ele => {
      if (ele.assignment) {

        return ele.assignment.assignment_type_id === 3
      }
    }) */
    
    // console.log(this.courseContent.courseAssignments)

  },
  methods: {
    
    redirectNextLesson () {
      console.log('hello')
      this.$emit('backToLesson', 0)
    },
    saveComplete (courseId) {
      console.log(courseId)
      const payload = {
        course_id: courseId,
        type: 1, 
        platform_customer_id:this.platform_customer_id
      }

      const isMarkDone = this.markComplete(payload)
      if (isMarkDone) {
        console.log('hi')
        this.courseContent.courseComplete = 1
      } else {
          this.$vs.notify({
          title: 'Warning',
          text: e.data.message,
          icon: 'feather',
          iconPack: 'icon-alert-circle',
          color:'warning'
        })
      }
    },
    downloadImage (item) {
      console.log(item)
      axios({
        url: `https://cors-anywhere.herokuapp.com/${item.file_path}`,
        method: 'GET',
        responseType: 'blob'
      })
        .then((response) => {
          const fileUrl = window.URL.createObjectURL(new Blob([response.data]))
          const fileLink = document.createElement('a')
          fileLink.href = fileUrl

          fileLink.setAttribute('download', item.file_name)
          document.body.appendChild(fileLink)

          fileLink.click()
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
          console.log('hi')
        })
    }
  }
}
</script>